import axios from 'axios';

const baseUrl = process.env.VUE_APP_API_BASE_URL;

export const subscribeSevaMedia = ({ phone, coupon }) => (
	axios.post(`${baseUrl}/sevamedia/subscription`, { phone, coupon })
);

